import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import "./LiveAndUpcoming.scss"
import VideoCarousel from "../../components/ReusableComponents/VideoCarousel/VideoCarousel"
import LiveClassTile from "../../components/ReusableComponents/LiveClassTile/LiveClassTile"
import ZeroState from "../../components/ReusableComponents/ZeroState/ZeroState"
import { selectIcon, SVG } from "../../components/UI/selector"
import {
  add,
  endOfDay,
  format,
  isSameDay,
  isToday,
  parseISO,
  startOfDay,
} from "date-fns"
import { LiveAndUpcomingApi } from "../../services/CallApi"
import ApiURL from "../../services/ApiURL"
import { ErrorUI } from "../../components/UI/Modals/Modals"
import { ZERO_STATE_TEXT } from "../../Constants/Texts"

const LiveAndUpcoming = ({ ...props }) => {
  const { defaultGym } = useSelector((state) => state.profile.profileData)
  const [selectedDay, setSelectedDay] = useState(new Date())
  const [selectedWeek, setSelectedWeek] = useState(0)
  const [upcoming, setUpcoming] = useState(null)
  const [liveActivities, setliveActivities] = useState(null)

  useEffect(() => {
    if (defaultGym) {
      getLiveAndUpcomingActivities([defaultGym.gym_id], false)
    }
  }, [defaultGym])

  useEffect(() => {
    const dateFilter = {
      from: startOfDay(selectedDay),
      to: endOfDay(selectedDay),
    }
    if (defaultGym) {
      getLiveAndUpcomingActivities([defaultGym.gym_id], true, dateFilter)
    }
  }, [selectedDay, defaultGym])

  const getLiveAndUpcomingActivities = (gymIds, all = true, date = null) => {
    const data = {
      limit: 10,
      offset: 0,
      gym_ids: JSON.stringify(gymIds),
    }
    if (all) {
      data["activity_status"] = ["SCHEDULED"]
    } else {
      data["activity_status"] = [
        "IN_WAITING_ROOM",
        "STARTED",
        "IN_HANGOUT_ROOM",
      ]
    }
    if (date) {
      data["dateFilter"] = date
    }
    LiveAndUpcomingApi(ApiURL._listLiveAndUpcomingActivities, data).then(
      (res) => {
        if (res.status) {
          if (all) {
            setUpcoming(res.list)
          } else {
            setliveActivities(res.list)
          }
        } else {
          ErrorUI(res.list, () =>
            getLiveAndUpcomingActivities(gymIds, all, date)
          )
        }
      }
    )
  }

  var days = []
  for (let i = 0; i < 7; i++) {
    const day = add(startOfDay(new Date()), { days: i + selectedWeek * 7 })
    const UAClass =
      upcoming &&
      upcoming.find((el) =>
        isSameDay(startOfDay(parseISO(el.start_datetime)), day)
      )
        ? " hasClass"
        : ""
    const todayClass = isToday(day) ? " today" : ""

    const selected = isSameDay(startOfDay(selectedDay), day) ? " selected" : ""

    days.push(
      <div
        key={i}
        className={"dateContainer box-layer2" + todayClass + UAClass + selected}
        onClick={() => setSelectedDay(day)}
      >
        <p>{format(day, "eee d")}</p>
      </div>
    )
  }

  const changeWeek = (next) => {
    if (next) {
      setSelectedWeek((week) => week + 1)
    } else {
      setSelectedWeek((week) => week - 1)
    }
  }

  return (
    <div className="LiveAndUpcomingScreen">
      {defaultGym && (
        <VideoCarousel heading="LIVE NOW">
          {liveActivities ? (
            liveActivities.length ? (
              <LiveClassTile activities={liveActivities} />
            ) : (
              <ZeroState
                icon={selectIcon("noLiveNow")}
                text={ZERO_STATE_TEXT.LIVE_NOW}
              />
            )
          ) : null}
        </VideoCarousel>
      )}
      <div className="calendarDiv box-layer1">
        <p className="calendarCurrentDate text-page-heading">
          {format(
            add(startOfDay(new Date()), { days: selectedWeek * 7 }),
            "MMMM, y"
          )}
        </p>
        <div className="calendarDateDivContainer">
          <div
            className="calendarNavigateDiv"
            onClick={() => changeWeek(false)}
          >
            <SVG src={selectIcon("leftArrow")} />
          </div>
          <div className="calendarNavigateButtonsDiv text-tab">{days}</div>
          <div className="calendarNavigateDiv" onClick={() => changeWeek(true)}>
            <SVG src={selectIcon("rightArrow")} />
          </div>
        </div>
      </div>
      {defaultGym && (
        <VideoCarousel heading="UPCOMING">
          {upcoming ? (
            upcoming.length ? (
              <LiveClassTile activities={upcoming} />
            ) : (
              <ZeroState
                icon={selectIcon("noLiveUpcomingForDay")}
                text={ZERO_STATE_TEXT.LIVE_UPCOMING_FOR_DAY}
              />
            )
          ) : null}
        </VideoCarousel>
      )}
    </div>
  )
}

export default LiveAndUpcoming
